@if (function() !== undefined) {
  <glxy-page>
    <glxy-page-toolbar>
      <glxy-page-nav>
        <glxy-page-nav-button [useHistory]="true" />
      </glxy-page-nav>
      @if (function()) {
        <glxy-page-title>{{ 'AI_ASSISTANT.FUNCTIONS.EDIT_FUNCTION.TITLE' | translate }}</glxy-page-title>
      } @else {
        <glxy-page-title>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.TITLE' | translate }}</glxy-page-title>
      }
    </glxy-page-toolbar>
    <glxy-page-wrapper [widthPreset]="'wide'">
      <ng-container [formGroup]="form">
        <!--      name-->
        <glxy-form-field bottomSpacing="small">
          <glxy-label>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.NAME' | translate }}</glxy-label>
          <input type="text" matInput formControlName="name" />
          @if (name?.errors?.pattern) {
            <glxy-error>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.NAME_PATTERN_ERROR' | translate }}</glxy-error>
          }
        </glxy-form-field>

        <!--      description-->
        <glxy-form-field>
          <glxy-label>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.DESCRIPTION' | translate }}</glxy-label>
          <input type="text" matInput formControlName="description" />
        </glxy-form-field>

        <!--      method and url-->
        <glxy-form-row>
          <glxy-form-field class="col-xs-12 col-sm-3" bottomSpacing="small">
            <glxy-label>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.METHOD' | translate }}</glxy-label>
            <mat-select formControlName="methodType">
              @for (option of httpMethodOptions; track option.value) {
                <mat-option [value]="option.value">{{ option.label }}</mat-option>
              }
            </mat-select>
          </glxy-form-field>
          <glxy-form-field class="col-xs-12 col-sm-9" bottomSpacing="small">
            <glxy-label>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.URL' | translate }}</glxy-label>
            <input
              type="text"
              matInput
              formControlName="url"
              placeholder="{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.URL_PLACEHOLDER' | translate }}"
            />
            @if (url?.errors?.['invalidHttpUrl']) {
              <glxy-error>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.URL_ERROR' | translate }}</glxy-error>
            } @else {
              <glxy-hint>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.URL_HINT' | translate }}</glxy-hint>
            }
          </glxy-form-field>
        </glxy-form-row>

        <!--      headers-->
        @if (!isGenerateResponseFunction()) {
          <div class="parameters-header">
            <h4>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.HEADERS' | translate }}</h4>
          </div>
          <ng-container formArrayName="headers">
            @if (headers.length === 0) {
              <mat-card class="empty">
                <mat-card-content
                  >{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.NO_HEADERS' | translate }}
                </mat-card-content>
              </mat-card>
            } @else {
              @for (header of headers.controls; let i = $index; track header) {
                <glxy-form-row [formGroupName]="i">
                  <glxy-form-field class="col-xs-12 col-sm-5" [hideRequiredLabel]="true" bottomSpacing="small">
                    <input
                      type="text"
                      matInput
                      formControlName="key"
                      placeholder="{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.HEADER_NAME_PLACEHOLDER' | translate }}"
                    />
                  </glxy-form-field>
                  <glxy-form-field class="col-xs-12 col-sm-6" [hideRequiredLabel]="true" bottomSpacing="small">
                    <input
                      type="text"
                      matInput
                      formControlName="value"
                      placeholder="{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.HEADER_VALUE_PLACEHOLDER' | translate }}"
                    />
                  </glxy-form-field>
                  <button mat-icon-button class="col-xs-12 col-sm-1" (click)="removeHeader(i)">
                    <mat-icon>close</mat-icon>
                  </button>
                </glxy-form-row>
              }
            }
            <div class="header-buttons">
              <button mat-button type="button" color="primary" class="add-button" (click)="addHeader()">
                {{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.ADD_HEADER' | translate }}
              </button>
              <button mat-button [matMenuTriggerFor]="menu" color="primary" type="button">
                {{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.ADD_COMMON_HEADER' | translate }}
                <mat-icon class="dropdown-arrow" iconPositionEnd>arrow_drop_down</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                @for (commonHeader of commonHeaderOptions; track commonHeader) {
                  <button mat-menu-item (click)="addHeader(commonHeader.header)">
                    {{ commonHeader.label }}
                  </button>
                }
              </mat-menu>
            </div>
          </ng-container>
        }

        <!--      parameters-->
        <div class="parameters-header">
          <h4>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.PARAMETERS' | translate }}</h4>
        </div>
        <div formArrayName="parameters" class="parameters-container">
          @if (parameters.length === 0) {
            <mat-card class="empty">
              <mat-card-content
                >{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.NO_PARAMETERS' | translate }}
              </mat-card-content>
            </mat-card>
          } @else {
            @for (parameter of parameters.controls; let i = $index; track parameter) {
              <div class="parameters">
                <ai-function-parameter
                  [formControl]="parameter"
                  (remove)="removeParameter(i)"
                  [disableDelete]="i === 0 && generateResponse?.value"
                ></ai-function-parameter>
              </div>
            }
          }
        </div>
        <button
          mat-button
          color="primary"
          type="button"
          class="add-parameter"
          (click)="addParameter({ type: ParameterType.STRING })"
        >
          {{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.ADD_PARAMETER' | translate }}
        </button>
      </ng-container>

      <!--    footer-->
      <ai-sticky-footer
        [submitOverride]="function() ? '' : ('AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.CREATE' | translate)"
        (submitClick)="submit()"
        (cancelClick)="cancel()"
        [disabled]="!canSave()"
      >
      </ai-sticky-footer>
    </glxy-page-wrapper>
  </glxy-page>
}
